import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";

export function useReservations() {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.admin.listReservationsWithDetails,
    authUserId ? { authUserId } : "skip",
  );
}

export function useCargosForReservation() {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.admin.getCargosForReservation,
    authUserId ? { authUserId } : "skip",
  );
}
